import { render, staticRenderFns } from "./Rulement.vue?vue&type=template&id=c403c098&scoped=true"
import script from "./Rulement.vue?vue&type=script&lang=js"
export * from "./Rulement.vue?vue&type=script&lang=js"
import style0 from "./Rulement.vue?vue&type=style&index=0&id=c403c098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c403c098",
  null
  
)

export default component.exports